//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formulaDetail } from '../../../server/oldformula/'
import { mapMutations } from 'vuex'
export default {
  name: 'SpirometricValues_info',
    data () {
    return {
      formulaInfo: {},
      content: [],
      refList: [],
      id: '1b451f3fd7d8aa9fb459e701b104c3b8'
    }
  },
  components: {},
  created () {
    this.hideLoad()
     this.id = this.$route.query.id ? this.$route.query.id : this.id
    this.getFormulaDetail()
  },
  methods: {
    ...mapMutations(['hideLoad']),
      async getFormulaDetail () {
      var params = {
        uuid: this.id
      }
      try {
        const res = await formulaDetail(params)
        this.formulaInfo = res
        if (this.formulaInfo.introExplain) {
          this.content = JSON.parse(this.formulaInfo.introExplain)
        }
        if (this.formulaInfo.referenceNew) {
          this.refList = JSON.parse(this.formulaInfo.referenceNew)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Pulm/SpirometricValues_info.vue